import {
    NetworkError,
    generateRouteDefinition,
    makeCanonicalUrl,
} from '@jet-app/music-classical/utilities';
import {
    makeLibraryRecentlyAddedPageIntent,
    type LibraryRecentlyAddedPageIntent,
} from './RecentlyAddedPageIntent';
import type { IntentController } from '@jet/environment/dispatching';
import type { RouteProvider } from '@jet/environment/routing';
import type { ObjectGraph } from '@jet/environment/dependencies';
import type { LibraryRecentlyAddedPage } from '@jet-app/music-classical/models/pages/library/recently-added';
import { IntentKind } from '@jet-app/music-classical/intents';
import { requestViewPage } from '@jet-app/music-classical/api/request-view-page';
import { renderSeeAllPage } from '../../see-all/renderSeeAllPage';
import {
    isEmptyPage,
    renderEmptyPage,
} from '@jet-app/music-classical/utilities/transforms/empty-view';
import { requiresSignIn } from '../utils/requires-sign-in';

const canonicalUrlRule = {
    path: '/library/recently-added',
    query: [],
};

export const LibraryRecentlyAddedPageIntentController: IntentController<LibraryRecentlyAddedPageIntent> &
    RouteProvider = requiresSignIn({
    $intentKind: IntentKind.LIBRARY_RECENTLY_ADDED_PAGE,

    routes: generateRouteDefinition<LibraryRecentlyAddedPageIntent>(
        canonicalUrlRule,
        makeLibraryRecentlyAddedPageIntent,
        { isLibrary: true },
    ),

    async perform(
        intent: LibraryRecentlyAddedPageIntent,
        objectGraph: ObjectGraph,
    ): Promise<LibraryRecentlyAddedPage> {
        const canonicalURL = makeCanonicalUrl(
            canonicalUrlRule,
            intent,
            objectGraph,
        );

        const apiResponse = await requestViewPage(
            `/recently-added`,
            objectGraph,
        );

        if (!apiResponse?.body) {
            throw NetworkError.noContent();
        }

        if (isEmptyPage(apiResponse)) {
            return renderEmptyPage<LibraryRecentlyAddedPage>(
                canonicalURL,
                apiResponse,
                objectGraph,
            );
        }

        const page = renderSeeAllPage(
            apiResponse,
            objectGraph,
            canonicalURL,
            false,
        ) as unknown as LibraryRecentlyAddedPage;

        return page;
    },
});
